import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
  YoutubeIcon,
} from 'lucide-react'

const Twitter = (props: { size?: number; className?: string }) => (
  <TwitterIcon {...props} />
)

const Youtube = (props: { size?: number; className?: string }) => (
  <YoutubeIcon {...props} />
)

const Facebook = (props: { size?: number; className?: string }) => (
  <FacebookIcon {...props} />
)

const Linkedin = (props: { size?: number; className?: string }) => (
  <LinkedinIcon {...props} />
)

const Instagram = (props: { size?: number; className?: string }) => (
  <InstagramIcon {...props} />
)

export { Twitter, Youtube, Facebook, Linkedin, Instagram }
